/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Compare_PickInputs */

const en_us2_body_assessment_compare_pick = /** @type {(inputs: Body_Assessment_Compare_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick two assessments. The older one goes on the left.`)
};

const pt_br2_body_assessment_compare_pick = /** @type {(inputs: Body_Assessment_Compare_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha duas avaliações. A mais antiga fica à esquerda.`)
};

const es_419_body_assessment_compare_pick = /** @type {(inputs: Body_Assessment_Compare_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige dos evaluaciones. La más antigua va a la izquierda.`)
};

const pt_pt2_body_assessment_compare_pick = /** @type {(inputs: Body_Assessment_Compare_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe duas avaliações. A mais antiga fica à esquerda.`)
};

const fr_fr2_body_assessment_compare_pick = /** @type {(inputs: Body_Assessment_Compare_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis deux évaluations. La plus ancienne va à gauche.`)
};

const de_de2_body_assessment_compare_pick = /** @type {(inputs: Body_Assessment_Compare_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle zwei Messungen. Die ältere kommt nach links.`)
};

const it_it2_body_assessment_compare_pick = /** @type {(inputs: Body_Assessment_Compare_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli due valutazioni. La più vecchia va a sinistra.`)
};

/**
* | output |
* | --- |
* | "Pick two assessments. The older one goes on the left." |
*
* @param {Body_Assessment_Compare_PickInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_compare_pick = /** @type {((inputs?: Body_Assessment_Compare_PickInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Compare_PickInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_compare_pick(inputs)
	if (locale === "es-419") return es_419_body_assessment_compare_pick(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_compare_pick(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_compare_pick(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_compare_pick(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_compare_pick(inputs)
	return en_us2_body_assessment_compare_pick(inputs)
});
export { body_assessment_compare_pick as "body-assessment.compare_pick" }